import React from "react"
import styled from "@emotion/styled"

const PageHeadingWrapper = styled.div`
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  > :first-of-type {
    margin: 0;
  }

  .actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;

    button {
      margin-right: 0;
      text-transform: none;
      font-weight: 700;
      border-radius: 10px;
      min-height: 38px;
    }
  }
`

const PageHeading = (props) => {
  return <PageHeadingWrapper>{props.children}</PageHeadingWrapper>
}

export default PageHeading
